import { Routes } from '@angular/router';
import { BannerComponent } from './banner.component';
import { AuthGuardService } from '../guards/auth-guard.service';
import { BannerCreateComponent } from './banner-create/banner-create.component';
import { BannerEditComponent } from './banner-edit/banner-edit.component';
import { BannerCategoriesComponent } from './banner-categories/banner-categories.component';

export const bannerRoutes: Routes = [
  {
    path: 'banner',
    canActivate: [ AuthGuardService ],
    children: [
      {
        path: 'create',
        component: BannerCreateComponent,
      },
      {
        path: ':bannerId/edit',
        component: BannerEditComponent,
      },
      {
        path: 'banner-categories/:bannerCategory',
        component: BannerCategoriesComponent,
      },
      {
        path: '',
        component: BannerComponent
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/app/banner/banner.routes.ts